/**
 * MXlab — nettoyage de l'arbre des titres.
 *
 * PROBLÈME : le sélecteur pays/langue natif (`snippets/localization-form.liquid`)
 * étiquette ses deux groupes avec des `<h2 class="visually-hidden">`, et il est rendu
 * DEUX fois (tiroir mobile + menu déroulant desktop). Résultat : quatre h2 précèdent
 * le h1 de la fiche produit dans l'arbre des titres.
 *
 * POURQUOI EN JS : le snippet est un fichier natif d'Horizon. On ne le forke pas —
 * une mise à jour du thème effacerait le correctif. On rétrograde donc après coup.
 *
 * ACCESSIBILITÉ : ces h2 sont redondants. Les contrôles qu'ils étiquettent portent
 * déjà leur propre nom accessible (`<select aria-label>` pour la langue, `<ul
 * aria-label>` pour la liste de pays). On remplace le h2 par un `<p>` visuellement
 * masqué qui garde le même texte et le même id : rien ne quitte l'ordre de lecture,
 * seule la sémantique de TITRE disparaît.
 *
 * POURQUOI UN OBSERVATEUR : `section-hydration.js` re-rend l'en-tête via la Section
 * Rendering API APRÈS le chargement, et remplace son DOM — un passage unique est
 * effacé quelques centaines de ms plus tard (constaté au navigateur). La section
 * hydratée se marque `data-hydrated="true"` : on repasse sur ce signal. Le filtre
 * d'attribut rend l'observateur quasi gratuit (aucun autre attribut ne le réveille).
 *
 * PORTÉE : correctif côté client. Le HTML servi contient toujours les h2 ; seul le
 * DOM rendu est corrigé. Un extracteur qui lit le HTML brut sans exécuter le JS les
 * verra encore. Et le script n'est chargé que par `mx-product` : les autres gabarits
 * (collections, accueil) gardent les quatre h2.
 */

const SELECTOR = 'h2.visually-hidden[id$="-CountryLabel"], h2.visually-hidden[id$="-LanguageLabel"]';

function demote(heading) {
  const p = document.createElement('p');
  p.className = heading.className;
  if (heading.id) p.id = heading.id;
  p.textContent = heading.textContent;
  heading.replaceWith(p);
}

function run() {
  document.querySelectorAll(SELECTOR).forEach(demote);
}

run();

new MutationObserver(run).observe(document.documentElement, {
  subtree: true,
  attributeFilter: ['data-hydrated'],
});
